<template>
    <ActionDialog
        v-model="internal_value"
        :title="title"
    >
        <template #content>
            <v-window
                v-model="window"
                :disabled="true"
            >
                <v-window-item value="date">
                    <RespiteDate
                        @cancel="internal_value = false"
                        @confirm="post_respite"
                    />
                </v-window-item>
                <v-window-item value="feedback">
                    <RespiteFeedback
                        :feedback="feedback"
                        @close="internal_value = false"
                    />
                </v-window-item>
            </v-window>
        </template>
    </ActionDialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { locales_mixin } from '@old/mixins/locales_mixin'
import RespiteDate from '@old/components/respite/RespiteDate.vue'
import { api_mixin } from '@old/mixins/api_mixin'
import RespiteFeedback from '@old/components/respite/RespiteFeedback.vue'
import { actions_mixin } from '@old/mixins/actions_mixin'
import ActionDialog from '@old/components/action_dialog/index.vue'

export default {
    name: 'Respite',
    props: {
        modelValue: {
            type: Boolean,
        },
    },
    mixins: [actions_mixin, api_mixin, locales_mixin],
    components: {
        ActionDialog,
        RespiteFeedback,
        RespiteDate,
    },
    data() {
        return {
            internal_value: false,
            feedback: null,
            window: 'date',
        }
    },
    computed: {
        title() {
            if (this.window !== 'feedback') return this.translate('common.postpone_your_payment')
            return ''
        },
        ...mapGetters([]),
        ...mapState(['respite']),
    },
    watch: {
        respite: {
            handler(respite) {
                if (Object.keys(respite.document).length) {
                    this.internal_value = true
                }
            },
            immediate: true,
            deep: true,
        },
        async internal_value(value) {
            if (!value) {
                await this.update_key_in_state_property({
                    property: 'respite',
                    key: 'document',
                    data: {},
                })
                if (this.window === 'feedback') {
                    await this.update_actions_render_key()
                }
                this.feedback = null
                this.window = 'date'
            }
        },
        feedback(value) {
            if (value) this.window = 'feedback'
        },
    },
    methods: {
        async post_respite(payload) {
            try {
                const { id } = this.respite.params
                await this.api_post({
                    url: `/domain-actions/cases/respite/${id}`,
                    data: { days: payload.days },
                })
                this.respite.document['next_flow_item']['schedule_to_execute'] = new Date(payload.date).toUTCString()
                this.feedback = 'success'
            } catch {
                this.feedback = 'failed'
            }
        },
        ...mapActions(['update_key_in_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
    unmounted() {},
}
</script>

<style scoped lang="sass"></style>
